var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('v-chip',{class:{ fullwidth: _vm.fullWidth },attrs:{"label":"","id":"chip"}},[(_vm.avatar)?_c('v-avatar',{attrs:{"left":""}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("mdi-numeric-"+_vm._s(_vm.number)+"-box")])],1):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }